import { Component } from '@angular/core';

@Component({
  selector: 'app-modals',
  imports: [],
  templateUrl: './modals.component.html',
  styleUrl: './modals.component.css'
})
export class ModalsComponent {

}
